<template>
    <div id="app">
        <el-container>
            <Header />
            <Gns />
            <div class="hea50" style="height: 150px;"></div>
            <!-- <div style="height: 150px;background: #fff;"></div> -->
            <main class="content">
                <keep-alive include="Shop,addActivity,addposition,editposition">
                    <router-view></router-view>
                </keep-alive>
            </main>
            <Footer />
            <Login v-if="showLogin" @logsuccess="jup" @regis="toregister" @verify="ver" @forgets="toforgets"
                @cal="showLogin = false"></Login>
            <Register @logss="showRe = false,showLogin=true" @verifys="veri" :type="identity" v-if="showRe"></Register>
            <Forgets @logss="showfo = false,showLogin = true" v-if="showfo" :type="identity"></Forgets>
        </el-container>
    </div>
</template>
<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/footer.vue'
    import Gns from '@/components/gns.vue'
    import Login from "@/components/login.vue"
    import Register from "@/components/register.vue"
    import Forgets from "@/components/forgets.vue"
    export default {
        components: {
            Header,
            Gns,
            Footer,
            Login,
            Register,
            Forgets
        },
        data() {
            return {
                showLogin: false,
                showRe: false,
                showfo: false,
                identity: 0,
                lastPageUrl: ""
            }
        },
        created() {
            console.log("route", this.$route)
        },
        mounted() {
            this.$bus.$on('openLoginModal', () => {
                if(this.$route.query.source == "register"){
                    this.showRe = true
                }else{
                    this.showLogin = true
                    this.lastPageUrl = this.$route.fullPath
                }
               
            })
            this.$bus.$on('closeLoginModal', () => {
                this.showLogin = false
            })
        },
        beforeDestroy() {
            // 销毁监听，防止内存泄漏
            this.$bus.$off('openLoginModal')
        },
        methods: {
            veri() {
                this.showRe = false
                this.$router.push({
                    path: '/verify'
                })
            },
            ver() {
                this.showLogin = false
                this.$router.push({
                    path: '/verify'
                })
            },
            jup() {

                if (this.lastPageUrl && this.lastPageUrl !== '/') {
                    // 方案A：跳转到记录页面，并且刷新页面（适合keep‑alive缓存页面）
                    // 先跳别的空页面再跳回来，触发页面刷新
                    this.$router.replace('/redirect').then(() => {
                        this.$router.replace(this.lastPageUrl)
                    })
                } else {
                    // 默认跳首页
                    this.showLogin = false
                    console.log(this.lastPageUrl)
                    this.$router.replace('/shopIndex')
                }
            },
            toregister(e) {
                if (e < 4) {
                    this.identity = 0
                } else {
                    this.identity = 1
                }
                this.showLogin = false
                this.showfo = false
                this.showRe = true
            },
            toforgets(e) {
                if (e < 4) {
                    this.identity = 0
                } else {
                    this.identity = 1
                }
                this.showLogin = false
                this.showRe = false
                this.showfo = true
            }
        }
    }
</script>
<style>
   body {
      overflow: visible !important;
    }
    .el-message {
        z-index: 999999 !important;
    }

    .tpis {
        font-size: 14px !important;
        color: #666;
        text-align: left;
        margin-top: 8px;
        box-sizing: border-box;
        padding: 0 6px;
    }

    .hea50 {
        height: 150px;
        /* background: pink; */
    }

    /* Edge、IE 密码框自带小眼睛 */
    input[type="password"]::-ms-reveal {
        display: none !important;
    }

    /* 清除input自带清除叉号 */
    input::-ms-clear {
        display: none !important;
    }

    /* webkit浏览器自动填充相关图标一并隐藏 */
    input[type="password"]::-webkit-contacts-auto-fill-button,
    input[type="password"]::-webkit-credentials-auto-fill-button {
        visibility: hidden;
        display: none !important;
        pointer-events: none;
        height: 0;
        width: 0;
    }

    .main-content {
        min-height: 54vh;
        background: #f8f8f8;
    }

    .bluebtn {
        box-sizing: border-box;
        padding: 11px;
        background: #DEEEFF;
        border-radius: 8px;
        font-size: 13px;
        color: #007AFF;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        display: inline-block;
    }

    .bluebtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }

    .el-container {
        display: block !important;
    }

    .greenbtn {
        box-sizing: border-box;
        padding: 11px;
        background: #E8F6EB;
        border-radius: 8px 8px 8px 8px;
        font-size: 13px;
        color: #4CC864;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        display: inline-block;
    }

    .redbtn {
        box-sizing: border-box;
        padding: 11px;
        background: #FBECED;
        border-radius: 8px 8px 8px 8px;
        font-size: 13px;
        color: #FF1024;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        display: inline-block;
    }

    .redbtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }

    .greenbtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }

    .gn .el-menu--horizontal .el-menu-item {
        padding: 0 0 !important;
    }

    html {
        scrollbar-width: none;
    }

    html::-webkit-scrollbar {
        display: none;
    }

    html,
    body {
        -ms-overflow-style: none;
        /* IE */
        /* overflow-x: hidden; */
        /* 如果需要隐藏横向滚动条 */
    }

    .caItem {
        margin-right: 40px;
        font-size: 16px !important;
        color: #4E5366;
        margin-bottom: 10px !important;
    }

    .cateName {
        font-weight: 600;
        font-size: 20px !important;
        color: #222222;
        margin-right: 40px;
    }

    .checkmopre {
        width: 108px !important;
        /* height: 17px; */
    }

    body {
        /* width: 1920px !important; */
    }

    .el-menu-item:hover {
        color: #007AFF !important;
    }

    .el-submenu__title:hover {
        color: #007AFF !important;
    }

    .el-menu--popup {
        min-width: 115px !important;
    }

    .el-menu--popup>>>.el-menu-item {
        height: 54px !important;
        line-height: 54px !important;
        text-align: center !important;
        border-bottom: 2px dashed #d9d9d9 !important;
    }

    .el-menu-item:hover {
        color: #409EFF !important;
    }

    .el-submenu__title:hover {
        color: #409EFF !important;
    }

    /* 
    .el-menu--horizontal .el-menu .el-menu-item {
        color: #409EFF !important;
        height: 54px !important;
        border-bottom: 2px dashed #d9d9d9 !important;
    } */

    .single {
        white-space: nowrap;
        /* 强制不换行 */
        overflow: hidden;
        /* 隐藏溢出内容 */
        text-overflow: ellipsis;
        /* 溢出显示省略号 */
        min-width: 0;
    }

    .multy2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /* 显示几行 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .multy3 {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        /* 显示几行 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* 全局页面滚动条 */
    ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background: #c5c8ce;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #999;
    }

    /* Firefox */
    html {
        scrollbar-width: thin;
        scrollbar-color: #c5c8ce transparent;
    }
    
    .el-button {
      display: inline-flex !important;
      justify-content: center !important;
      align-items: center !important;
    }
    
    .content {
        min-height: 52vh;
        background: #f8f8f8;
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        width: 100%;
        height: 100vh;
        /* height: 100vh;
        width: calc(100% / 0.85);
        transform: scale(0.85);
        transform-origin: 0 0; */
    }

    * {

        padding: 0;
        margin: 0;

    }

    .flx {
        display: flex;
    }

    .alc {
        align-items: center;
    }

    .jsb {
        justify-content: space-between;
    }

    .jsc {
        justify-content: center;
    }

    .cursor {
        cursor: pointer;
    }
</style>